import { SocialSharing } from '@change/ds-core-ui/SocialSharing';

import { type TranslatableLabel, useResolvedLabel } from '#src/app/shared/hooks/i18n';
import type { ShareAction as ShareActionType } from '#src/app/shared/hooks/share';

import { useSocialIconWithSuccessState } from './hooks/useSocialIconWithSuccessState';

type SocialSharingVariant = React.ComponentProps<typeof SocialSharing>['variant'];
type SocialSharingSize = React.ComponentProps<typeof SocialSharing>['size'];

type Props = {
	buttonConfig: {
		ShareAction: ShareActionType['ShareAction'];
		icon: React.ReactElement;
		label: TranslatableLabel;
		successLabel?: TranslatableLabel;
		variant?: SocialSharingVariant;
	};
	size?: SocialSharingSize;
	onAfterShare?: (success: boolean) => void;
} & Omit<React.ComponentProps<typeof SocialSharing>, 'label' | 'icon' | 'variant' | 'size' | 'onClick'>;

export const SocialIconWithSuccessState = ({
	buttonConfig: { ShareAction, icon, label, successLabel, variant },
	size = 'large',
	onAfterShare,
	...rest
}: Props): React.ReactElement => {
	const { data, actions } = useSocialIconWithSuccessState({ label, successLabel });
	const currentLabel = useResolvedLabel(data.currentLabel);

	return (
		<ShareAction
			onAfterAction={(success) => {
				actions.afterShare(success);
				onAfterShare?.(success);
			}}
		>
			<SocialSharing icon={icon} label={currentLabel} variant={variant ?? 'default'} size={size} {...rest} />
		</ShareAction>
	);
};
